import { Modal } from "@breuni-ui/modal";
import { safeDefine } from "@breuni-ui/safe-define";

export class KombiModulModal extends Modal {}

safeDefine("reco-kombi-modul-modal", KombiModulModal);
